import React from "react";
import { Line } from "react-chartjs-2";
import "./style.css";

const LineChart = ({ chartData, title }) => {
  return (
    <div className="chart-container">
      <Line
        datasetIdKey="id"
        data={chartData}
        options={{
          plugins: {
            title: {
              display: true,
              text: title,
            },
            legend: {
              display: false,
            },
          },
        }}
      />
    </div>
  );
};
export default LineChart;
